module.exports = __webpack_public_path__ + "147f39aadafa824813c509e19e81887c.png";